"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSelectedOptionName;

var _getNormalizeValue2 = _interopRequireDefault(require("./getNormalizeValue"));

function getSelectedOptionName(value) {
  if (value) {
    var _getNormalizeValue = (0, _getNormalizeValue2["default"])(value),
        name = _getNormalizeValue.name;

    return name;
  }

  return undefined;
}